import { useApp } from '@retainerclub/hooks';
import { useMemo } from 'react';
import FieldContainer from '../../../../shared/FormElements/FieldContainer/FieldContainer';
import RcSelect from '../../../../shared/FormElements/Selects/RcSelect';

const userIssueOptions = [
  { id: 'does_not_fit', name: "Doesn't fit properly" },
  { id: 'manufacturing_issue', name: 'Manufacturing Issue / Defect' },
];

function WarrantyFormUserIssue() {
  const { isAdmin } = useApp();

  const options = useMemo(
    () =>
      isAdmin
        ? [...userIssueOptions, { id: 'lost_shipment', name: 'Lost Shipment' }]
        : userIssueOptions,
    [isAdmin],
  );

  return (
    <FieldContainer name="userIssue" label="What's the issue?" required={true}>
      <RcSelect name="userIssue" data={options} clearable={false} />
    </FieldContainer>
  );
}

export default WarrantyFormUserIssue;
